<template lang="html">
  <div id="Sidebar" class="gm-shadow" :style="sidebarStyle">
    <div class="gm-layout-vertical" :style="sidebarContainerStyle">
      <div class="gm-layout-horizontal" style="flex: 2; overflow: auto;">
        <!-- Sidebar Navigation -->
        <div class="tab-nab">
          <div class="tab gm-layout-horizontal">
            <div class="gm-layout-vertical">
              <div :class="{'item': true, 'selected': 0 === selectedTeam}" @click="teamSelected(0)">Info</div>
              <div v-for="(team, index) of project.projectInfo.teamsNum" :key="index">
                <div :class="{'item': true, 'selected': team === selectedTeam}" @click="teamSelected(team)">{{ team + '팀' }}</div>
              </div>
            </div>
            <div class="tab-rail" :style="tabRailStyle">
              <div class="tab-nav" :style="tabNavStyle"></div>
            </div>
          </div>
        </div>
        <!-- Sidebar Content -->
        <div class="tab-container gm-layout-match-parent">
          <!-- Project Info -->
          <div v-if="selectedTeam === 0">
            <!-- 프로젝트 명 -->
            <div style="color: var(--primary-color); font-weight: 700; font-size: 1.3rem;">
              {{ project.projectInfo.name }}
            </div>
            <!-- 프로젝트 설명 -->
            <div class="section">
              <div class="content gm-line-break">{{ project.projectInfo.desc }}</div>
            </div>
            <!-- 프로젝트 비밀번호 -->
            <div class="section" v-if="isProjectOwner">
              <div class="title">프로젝트 비밀번호</div>
              <div class="content">{{ project.projectInfo.pw }}</div>
            </div>
            <!-- 참여 인원 -->
            <div class="section">
              <div class="title">참여인원</div>
              <div class="content">{{ project.projectInfo.participantsNum + '명' }}</div>
            </div>
            <!-- 전체 마커 수 -->
            <div class="section">
              <div class="title">전체 마커 수</div>
              <div class="content">{{ project.projectInfo.markersNum + '개' }}</div>
            </div>
            <!-- 진행상황 -->
            <div class="section progress">
              <div class="title">진행상황</div>
              <!-- <div class="title">진행상황</div> -->
              <!-- 전체 진행상황 -->
              <div class="gm-layout-horizontal" style="padding: 4px;">
                <span class="label" style="width: 60px;" v-if="progress.totalDone < project.projectInfo.markersNum">{{`전체 (${progress.totalDone}/${project.projectInfo.markersNum})`}}</span>
                <span class="label" style="width: 60px;" v-else>전체 (완료)</span>
                <el-progress :text-inside="true" :stroke-width="15" :format="progressFormat" :percentage="progress.totalProgress" style="flex: 1; margin-left: 8px; padding: 0px;" />
              </div>
              <!-- 팀 별 진행상황 -->
              <div v-for="(teamProgress, index) of progress.progressByTeam" :key="index">
                <div class="gm-layout-horizontal" style="padding: 4px;">
                  <span class="label" style="width: 60px;" v-if="teamProgress.doneNum < teamProgress.totalNum">{{ `${index + 1}팀 (${teamProgress.doneNum}/${teamProgress.totalNum})` }}</span>
                  <span class="label" style="width: 60px;" v-else>{{ `${index + 1}팀 (완료)` }}</span>
                  <el-progress :text-inside="true" :format="progressFormat" :stroke-width="15" :percentage="teamProgress.doneNum/teamProgress.totalNum * 100" style="flex: 1; margin-left: 8px; padding: 0px;" />
                </div>
              </div>
            </div>
          </div>
          <!-- Team -->
          <div v-for="(team, teamIndex) of project.projectInfo.teamsNum" :key="teamIndex" v-if="selectedTeam === team">
            <div class="marker" v-for="(marker, markerIndex) in project.mapData.team[team - 1]" :key="markerIndex" @click.self="markerSelected(marker, teamIndex, markerIndex)">
              <div @click.self="markerSelected(marker, teamIndex, markerIndex)">
                <div class="marker-title" @click.self="markerSelected(marker, teamIndex, markerIndex)">{{ marker.name }}</div>
                <div class="marker-address" style="margin: 8px 6px 8px 0px;" @click.self="markerSelected(marker, teamIndex, markerIndex)">{{ marker.address }}</div>
                <div class="marker-phone">
                  <a :href="'tel:' + marker.phone">{{ marker.phone }}</a>
                </div>
              </div>
              <div style="margin: auto 0 auto auto;" @click.self="markerSelected(marker, teamIndex, markerIndex)">
                <vs-switch color="success" v-model="project.markerState[team - 1][markerIndex]" @input="changeState(teamIndex, markerIndex)" style="width: 48px; margin-right: 4px;">
                  <span slot="on">완료</span>
                  <span slot="off"></span>
                </vs-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sidebar Bottom -->
      <div class="tab-bottom gm-align-vertical-center" style="height: 42px; border-top: 1px solid var(--gray-color); padding: 4px 8px;">
        <div style="margin-left: auto;">
          <el-button type="primary" size="small" icon="el-icon-edit" circle @click="showModifyDialog" v-if="isProjectOwner" />
          <el-button type="primary" size="small" icon="el-icon-share" circle @click="onClickToShare" />
        </div>
      </div>
    </div>
    <!-- ModifyDialog -->
    <ModifyDialog />
  </div>
</template>
<script>
import ModifyDialog from '@/components/Project/Sidebar/ModifyDialog'
import { db } from '@/firebase'
export default {
  name: 'Sidebar',
  components: {
    ModifyDialog
  },
  props: {
    project: Object,
    changeState: Function
  },
  data: () => ({
    showSidebar: true,
    sidebarStyle: {
      width: '0',
      transition: 'width .3s ease',
      maxHeight: '100%'
    },
    sidebarContainerStyle: {
      height: '100%',
      opacity: '0',
      transition: 'opacity .1s ease'
    },
    tabItemHeight: 40,
    tabRailHeight: '80px',
    navMarginTop: '0px',
    selectedTeam: 0,
    isProjectOwner: false,
    projectDB: null
  }),
  mounted() {
    const uid = this.$route.params.uid
    const pid = this.$route.params.pid
    this.projectDB = db.collection('projects').doc(uid).collection(pid)
    if (this.$store.state.isMobile) {
      this.tabItemHeight = 50
    } else {
      this.tabItemHeight = 40
    }

    this.$event.$on(this.$eventList.showSidebar, isShow => {
      this.showSidebar = isShow
      if (this.$store.state.isMobile) {
        this.sidebarStyle.width = (isShow) ? '85vw' : '0px'
      } else if (this.$store.state.isTablet) {
        this.sidebarStyle.width = (isShow) ? '60vw' : '0px'
      } else {
        this.sidebarStyle.width = (isShow) ? '35vw' : '0px'
      }
      this.sidebarStyle.transition = (isShow) ? 'width .3s ease' : 'width .3s ease .05s'
      this.sidebarContainerStyle.transition = (isShow) ? 'opacity .1s ease .15s' : 'opacity .1s ease'
      this.sidebarContainerStyle.opacity = (isShow) ? '1' : '0'
    })

    // Open sidebar automatically.
    if (!this.$store.state.isMobile) {
      setTimeout(_ => {
        this.$event.$emit(this.$eventList.showSidebar, true)
      }, 1000)
    }

    this.$event.$on(this.$eventList.isProjectOwner, isProjectOwner => {
      this.isProjectOwner = isProjectOwner
    })

    this.$event.$on(this.$eventList.teamsNum, teamsNum => {
      const railHeight = (teamsNum + 1) * this.tabItemHeight
      this.tabRailHeight = String(railHeight) + 'px'
    })
  },
  beforeDestroy() {
    this.$event.$off([
      this.$eventList.showSidebar,
      this.$eventList.isProjectOwner,
      this.$eventList.teamsNum
    ])
  },
  methods: {
    markerSelected(marker, teamIndex, markerIndex) {
      const markerInfo = {
        'marker': marker,
        'teamIndex': teamIndex,
        'markerIndex': parseInt(markerIndex)
      }
      this.$event.$emit(this.$eventList.markerSelected, markerInfo)
    },
    showModifyDialog() {
      this.$event.$emit(this.$eventList.showModifyDialog, true, this.project.projectInfo)
    },
    teamSelected(team) {
      this.$log.d('selected team :', team)
      this.selectedTeam = team
      this.navMarginTop = String(this.tabItemHeight * team) + 'px'
    },
    progressFormat(percentage) {
      return percentage === 100 ? '완료' : `${Math.round(percentage)}%`
    },
    onClickToShare() {
      const url = window.location.href
      if (this.$store.state.isMobile) {
        this.linkToKakao(url)
      } else {
        this.copyUrl(url)
      }
    },
    copyUrl(url) {
      let el = document.createElement('textarea')
      el.value = url
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$vs.notify({
        title: '프로젝트 URL 복사 완료!',
        text: 'URL을 공유하세요 🐈',
        color: 'success',
        icon: 'error',
        time: 3000,
        position: 'top-center'
      })
    },
    linkToKakao() {
      const url = window.location.href
      const title = this.project.projectInfo.name
      const desc = this.project.projectInfo.desc + '\n(비밀번호 : ' + this.project.projectInfo.pw + ')'
      // const imageUrl = 'https://firebasestorage.googleapis.com/v0/b/gentle-map.appspot.com/o/static%2Flogo_white.png?alt=media&token=d53de00d-a0cd-47ca-8af7-ac88e946fc2d'
      const imageUrl = 'https://firebasestorage.googleapis.com/v0/b/gentle-map.appspot.com/o/static%2Fkakao_link_img.jpg?alt=media&token=7128ee30-0b0d-4045-9fc7-e07c71f47500'
      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: title,
          description: desc,
          imageUrl: imageUrl,
          imageWidth: 5497,
          imageHeight: 3665,
          link: {
            mobileWebUrl: url,
            webUrl: url
          }
        },
        buttons: [{
          title: '프로젝트 시작',
          link: {
            mobileWebUrl: url,
            webUrl: url
          }
        }]
      })
    }
  },
  computed: {
    tabRailStyle() {
      return {
        '--rail-height': this.tabRailHeight
      }
    },
    tabNavStyle() {
      return {
        '--nav-margin-top': this.navMarginTop
      }
    },
    progress() {
      const progress = {
        totalDone: 0,
        totalProgress: 0, // 전체 진행상황
        progressByTeam: [] // 팀 별 진행상황
      }

      // let loadedStateNum = 0
      // this.project.markerState.forEach(states => {
      //   loadedStateNum += states.length
      // })

      // console.log('loadedStateNum', loadedStateNum)
      // console.log('this.project.projectInfo.markersNum', this.project.projectInfo.markersNum)
      // if (loadedStateNum !== this.project.projectInfo.markersNum) {
      //   this.$log.d('sidebar markerState not loaded')
      //   return progress
      // }
      this.$log.d('sidebar markerState loaded', this.project)

      const totalNum = this.project.projectInfo.markersNum
      var doneNum = 0
      this.project.markerState.forEach((team, teamIndex) => {
        progress.progressByTeam.push({
          doneNum: 0,
          totalNum: Object.keys(team).length,
          isDone: false
        })
        Object.keys(team).forEach(markerIndex => {
          const isDone = team[markerIndex]
          if (isDone) {
            doneNum++
            const teamProgress = progress.progressByTeam[teamIndex]
            teamProgress.doneNum++
            teamProgress.isDone = teamProgress.doneNum === teamProgress.totalNum
          }
        })
      })
      progress.totalDone = doneNum
      progress.totalProgress = doneNum / totalNum * 100 | 0
      return progress
    }
  }
}

</script>
<style lang="scss" scoped>
#Sidebar {
  z-index: 1999;
  background-color: white;
  height: 100vh;
  overflow: hidden;
  --tab-item-height: 40px;

  /* Tab */
  .tab-nab {
    overflow-x: hidden;
    overflow-y: auto;

    .tab {
      height: 100%;
      width: 57px;
      display: flex;
      text-align: center;
      vertical-align: center;
      overflow: auto;
      padding: 0px 8px 0px 0px;

      .item {
        height: var(--tab-item-height);
        width: 40px;
        line-height: var(--tab-item-height);
        cursor: pointer;
        font-weight: 700;
      }

      .selected {
        color: var(--primary-color);
      }

      .item:hover {
        color: var(--primary-color);
      }

      /* Tab Rail */
      .tab-rail {
        min-height: 100%;
        height: var(--rail-height);
        background-color: var(--gray-color);
        width: 2px;

        .tab-nav {
          background-color: var(--primary-color);
          width: 2px;
          margin-top: var(--nav-margin-top);
          transition: margin 0.3s ease;
          height: var(--tab-item-height);
        }
      }
    }
  }

  /* Tab Container */
  .tab-container {
    padding: 8px 8px 52px 4px;
    overflow: auto;

    .section {
      padding: 16px 0px;
      border-bottom: 1px solid var(--gray-color);

      .title {
        font-size: 1.1rem;
        font-weight: 700;
        margin-bottom: 8px;
      }

      .content {
        font-size: 1rem;
        padding-left: 4px;
      }
    }
  }

  .progress .label {
    width: 30px;
    text-align: center;
    font-size: 0.8rem;
  }

  .vs-list {
    padding: 4px 0px 4px 4px;
  }

  .vs-sidebar--items {
    padding: 0px !important;
  }

  .vs-collapse-item--header {
    padding: 0px 0px 4px 0px;
  }

  .con-section--item {
    padding: 0px 2px 0px 0px;
  }

  .marker {
    padding: 4px;
    display: flex;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
    padding: 8px 0px;
    cursor: pointer;
  }

  .marker-title {
    font-weight: 550;
    font-size: 1rem;
    margin-bottom: 4px;
  }

  .marker-address {
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .marker-phone {
    font-size: 1rem;
  }
}

/* Mobile */
@media only screen and (max-width : 768px) {
  #Sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: 0px;
    z-index: 2002;
    --tab-item-height: 50px;

    /* Tab */
    .tab-nab {
      .tab {
        padding: 0px 8px 0px 0px;
      }
    }

    /* Tab Container */
    .tab-container {
      padding: 8px 4px 8px 4px;
    }

    /* Tab Container */
    .tab-container {
      .section {
        .title {
          font-size: 1.2rem;
        }

        .content {
          font-size: 1.1rem;
        }
      }
    }

    .marker-title {
      font-size: 1.1rem;
    }

    .marker-address {
      font-size: 1rem;
    }

    .marker-phone {
      font-size: 1.1rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Project/Sidebar/index.vue